interface DataLayerAnalyticsRouteOptions {
  action?: string;
  isCmsUI?: boolean;
}

export const shouldRenderDataLayerAnalytics = ({
  action,
  isCmsUI,
}: DataLayerAnalyticsRouteOptions) => action === 'view' && !isCmsUI;
